module.exports = "https://99designs-start-assets.imgix.net/js/d013bcf609855a13e98b2d3be2ca87d9.svg";